import React, { useState } from 'react';
import { Navbar, Nav, Container, Dropdown } from 'react-bootstrap';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './CustomNavbar.css';

const CustomNavbar = ({ season, onSeasonChange, seasons }) => {
    const navigate = useNavigate();
    const { isAuthenticated, handleLogout } = useAuth();
    const [expanded, setExpanded] = useState(false);

    const handleSeasonChange = (value) => {
        onSeasonChange(value);
        setExpanded(false);
    };

    const collapseNav = () => setExpanded(false);

    return (
        <Navbar bg="light" expand="lg" expanded={expanded}>
            <Container fluid className="px-4">
                <Navbar.Brand as={Link} to="/" onClick={collapseNav}>
                    <img
                        src="/android-chrome-192x192.png"
                        alt="LZS"
                        height="32"
                        className="me-2"
                        style={{ objectFit: 'contain' }}
                    />
                    Średzka LZS
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto navbar-nav align-items-center">
                        <Nav.Link as={NavLink} to="/" onClick={collapseNav} end>Aktualności</Nav.Link>
                        <Nav.Link as={NavLink} to="/tabela" onClick={collapseNav}>Tabela</Nav.Link>
                        <Nav.Link as={NavLink} to="/puchar" onClick={collapseNav}>Puchar</Nav.Link>
                        <Nav.Link as={NavLink} to="/terminarz" onClick={collapseNav}>Terminarz</Nav.Link>
                        <Nav.Link as={NavLink} to="/wyniki" onClick={collapseNav}>Wyniki</Nav.Link>
                        <Nav.Link as={NavLink} to="/strzelcy" onClick={collapseNav}>Strzelcy</Nav.Link>
                        <Nav.Link as={NavLink} to="/kartki" onClick={collapseNav}>Kartki</Nav.Link>
                        <Dropdown className="mx-2">
                            <Dropdown.Toggle variant="outline-secondary" id="dropdown-seasons" size="sm">
                                {season}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {seasons.map(s => (
                                    <Dropdown.Item
                                        key={s.value}
                                        active={season === s.value}
                                        onClick={() => handleSeasonChange(s.value)}
                                    >
                                        {s.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Nav>
                    <Nav style={{ width: 'auto' }}>
                        {isAuthenticated ? (
                            <>
                                <Nav.Link as={NavLink} to="/admin" onClick={collapseNav}>
                                    Panel
                                </Nav.Link>
                                <Nav.Link as="button" onClick={() => { handleLogout(); collapseNav(); }}>
                                    Wyloguj
                                </Nav.Link>
                            </>
                        ) : (
                            <Nav.Link as="button" onClick={() => { navigate('/login'); collapseNav(); }}>
                                Zaloguj
                            </Nav.Link>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default CustomNavbar;
